import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f34e728"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-offset-2 col-sm-8" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Organisations you're accredited for")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "table table-hover" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date created"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import axios from "axios";
import moment from "dayjs";
import { debug as d } from "debug";
import { computed, onMounted, ref } from "vue";
import { OrganisationAndMembersApiModel, OrganisationDescriptionApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'accredited-user-area-organisation-list-page',
  setup(__props) {

const debug = d("cs.AccreditedUserAreaOrganisationListPage");

const visibleOrganisations = ref<OrganisationDescriptionApiModel[]>([]);

const saveInProgress = ref(false);

const canMoveOrganisations = computed(() => {
  return !!visibleOrganisations.value && visibleOrganisations.value.length > 1;
});

function formatDate(dateString: string): string | null {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : null;
}

async function loadModel() {
  debug("loadModel started");
  visibleOrganisations.value = [];
  saveInProgress.value = true;
  visibleOrganisations.value = (await axios.get("/api/accrediteduserarea/organisation")).data;
  saveInProgress.value = false;
  debug("loadModel finished");
}

onMounted(async () => {
  debug("Mounted");
  await loadModel();
});

return (_ctx: any,_cache: any) => {
  const _directive_data_table = _resolveDirective("data-table")!

  return (visibleOrganisations.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["organisations-page container", { updating: saveInProgress.value }])
      }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("div", {
            class: "col-sm-offset-2 col-sm-8",
            key: visibleOrganisations.value.length
          }, [
            _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleOrganisations.value, (org) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: org.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: '/myorganisation/details/' + org.id,
                        "data-test": "org-name"
                      }, _toDisplayString(org.name), 9, _hoisted_6)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(formatDate(org.dateCreated)), 1),
                    _hoisted_7
                  ]))
                }), 128))
              ])
            ])), [
              [_directive_data_table, 
            visibleOrganisations.value.length && {
              paging: false,
              searching: true,
              info: true,
              columnDefs: [{ targets: 2, orderable: false }],
              order: [[0, 'asc']],
            }
          ]
            ])
          ]))
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})